import React from "react";
import Card from "components/card";
import PieChart from "components/charts/PieChart";

const SODTypePieChart = ({ data, title = "Type Distribution" }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Card extra="p-4">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
          {title}
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400">No type data available</p>
        </div>
      </Card>
    );
  }

  // Calculate total for percentage calculation
  const total = data.reduce((sum, item) => sum + parseInt(item.count), 0);
  
  // Prepare chart data with percentages
  const chartData = data.map(item => {
    const count = parseInt(item.count);
    const percentage = total > 0 ? (count / total) * 100 : 0;
    return {
      name: item.typeName || item.typename || item.type || 'Unknown',
      value: count,
      percentage: percentage.toFixed(1)
    };
  });

  // Sort by count descending
  chartData.sort((a, b) => b.value - a.value);

  // Generate distinct pastel colors for the pie chart (darker shades)
  const colors = [
    "#FF8A9A", "#8AFF9A", "#8AC9FF", "#E6D4A3", "#FF8AF7",
    "#8AFFD6", "#FFB28A", "#D68AFF", "#8AF7FF", "#D4E6A3",
    "#FF8AD9", "#D9FF8A", "#8AD9FF", "#E6C4A3", "#F78AFF"
  ];

  return (
    <Card extra="p-4">
      <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
        {title}
      </h4>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="flex items-center justify-center">
          <PieChart
            series={chartData.map(item => item.value)}
            options={{
              labels: chartData.map(item => item.name),
              colors: colors.slice(0, chartData.length),
              chart: {
                width: "100%",
                height: 300,
                fontFamily: "DM Sans, sans-serif"
              },
              states: {
                hover: {
                  filter: {
                    type: "none",
                  },
                },
                active: {
                  filter: {
                    type: "none",
                  },
                },
              },
              legend: {
                position: "bottom",
                fontFamily: "DM Sans, sans-serif",
                fontSize: "12px"
              },
                             dataLabels: {
                 enabled: true,
                 formatter: function (val, opts) {
                   return val.toFixed(1) + '%';
                 },
                 style: {
                   fontSize: "11px",
                   fontFamily: "DM Sans, sans-serif"
                 }
               },
                             tooltip: {
                 enabled: true,
                 theme: "dark",
                 style: {
                   fontSize: "12px",
                   fontFamily: "DM Sans, sans-serif"
                 },
                 y: {
                   formatter: function(value, { seriesIndex }) {
                     if (chartData[seriesIndex]) {
                       const percentage = chartData[seriesIndex].percentage;
                       return `${value} (${percentage}%)`;
                     }
                     return `${value}`;
                   }
                 }
               }
            }}
          />
        </div>
        <div className="flex flex-col justify-center">
          <div className="space-y-3">
            <h5 className="text-sm font-semibold text-navy-700 dark:text-white font-dm">
              Type Breakdown
            </h5>
            {chartData.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <div className="flex items-center space-x-2">
                  <div 
                    className="w-3 h-3 rounded-full" 
                    style={{ backgroundColor: colors[index % colors.length] }}
                  ></div>
                  <span className="text-sm font-medium text-navy-700 dark:text-white font-dm">
                    {item.name}
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-bold text-navy-700 dark:text-white font-dm">
                    {item.value}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400 font-dm">
                    {item.percentage}%
                  </div>
                </div>
              </div>
            ))}
            <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <span className="text-sm font-semibold text-navy-700 dark:text-white font-dm">
                  Total
                </span>
                <span className="text-sm font-bold text-navy-700 dark:text-white font-dm">
                  {total}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SODTypePieChart; 